import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DepartmentService } from '../../services/department.service';
import { EmployeeService } from '../../services/employee.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-read-department',
    templateUrl: './read-department.component.html',
    styleUrls: ['./read-department.component.css', '../../app.component.css']
})

export class ReadDepartmentComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    departments: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Nombre', name: 'name' },
        { title: 'Observaciones', name: 'comments' },
        { title: 'Responsable', name: 'responsibleName' },
        { title: 'Aplica Rep. Apuntador', className: 'center', name: 'applyInPrompterReport' },
        { title: 'Aplica Rep. Supervisor', className: 'center', name: 'applyInSupervisorReport' },
        { title: 'Aplica Reloj Checador', className: 'center', name: 'applyInCheckClock' },
        { title: 'Aplica Rep. Seguridad', className: 'center', name: 'applySecurityReport' },
        { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
              styleClass: 'btn-floating btn waves-effect light-green darken-1' },
            { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
              styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: false,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
            onEdit: this.onEdit.bind(this),
            onDelete: this.onDelete.bind(this)
        }
    };

    gdSubs: any;
    geSubs: any;

    permissions = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: DepartmentService,
        private employeeService: EmployeeService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
          permissionsSubs.unsubscribe();
          this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
          if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
          else this.allowed = true;
        });

        this.loadDepartments();
    }

    ngOnInit() {

    }

    loadDepartments() {
        this.gdSubs = this.service.getDepartments().subscribe(tempDepartments => {
            this.gdSubs.unsubscribe();

            this.departments = [];

            let sub = this.employeeService.getEmployees().subscribe(employees => {
                sub.unsubscribe();
                let employeesInfo = employees.reduce((acc, cur) => ({[`${cur.id$}`]: cur.name, ...acc}), {});
                for (const idx in tempDepartments) {
                    tempDepartments[idx].responsibleName = (tempDepartments[idx].responsibleId ? employeesInfo[tempDepartments[idx].responsibleId] || '-' : '-');
                    tempDepartments[idx].applyInPrompterReport = (tempDepartments[idx].applyInPrompterReport === undefined) ? ' - ' :
                                                    (tempDepartments[idx].applyInPrompterReport) ? ' Sí ' : ' No ';
                    tempDepartments[idx].applyInSupervisorReport = (tempDepartments[idx].applyInSupervisorReport === undefined) ? ' - ' :
                                                    (tempDepartments[idx].applyInSupervisorReport) ? ' Sí ' : ' No ';
                    tempDepartments[idx].applyInCheckClock = (tempDepartments[idx].applyInCheckClock === undefined) ? ' - ' :
                                                    (tempDepartments[idx].applyInCheckClock) ? ' Sí ' : ' No ';
                    tempDepartments[idx].applySecurityReport = tempDepartments[idx].applySecurityReport ? 'Sí' : 'No';

                    this.departments.push(tempDepartments[idx]);
                }

                if(localStorage.re_dep__page){
                    this.page = +localStorage.re_dep__page;
                }
                if(localStorage.re_dep_filterStr){
                    this.config.filtering.filterString = localStorage.re_dep_filterStr;
                }
                this.config.paging = true;
                
                this.data = this.departments;
                this.length = this.data.length;
                this.onChangeTable(this.config);
            });


        });
    }

    onCellClick(data: any): any {
        this.router.navigate(['/vw_department/' + data.row.id$]);
    }

    onCreate(){
      if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
      this.router.navigate(['/add_department']);
    }

    onEdit(data: any) {
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
        this.router.navigate(['/edt_department/', data.row.id$]);
    }

    onDelete(data: any) {
        if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
        this.service.delDepartment(data.row.id$);
        this.loadDepartments();
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
		localStorage.re_dep__page = `${page.page}`;
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        localStorage.re_dep_filterStr = this.config.filtering.filterString;
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
